export default __webpack_public_path__ + "static/media/ico-sq-12-production.728b3048.svg";